module.exports = __webpack_public_path__ + "static/flight-or-fright-2a10f3365215988230e0edf942d541e5.jpg";